import { ArrowBigDown, ArrowBigDownDash, ArrowDown, ChevronDown, ChevronRight, ChevronsDown, Dot, MoveDown, SquareChevronDown, Triangle } from "lucide-react";
import { Button } from "../../ui/Button";
import { DropdownMenu } from "../../ui/DropDown/DropdownMenu";
import { DropdownMenuTrigger } from "../../ui/DropDown/DropdownMenuTrigger";
import { DropdownMenuContent } from "../../ui/DropDown/DropdownMenuContent";
import { type FAQIcon, useFAQEditor } from "./Context/FaqEditorContext";

export type IconItem = {
    key: string;
    label: string;
    icon: React.ReactNode;
    name: string;
}

export const ICONS: IconItem[] = [
    {
        icon: <ChevronDown size={24} />,
        key: "icon-chevron-down",
        label: "chevron-down",
        name: 'chevron-down',
    },
    {
        key: "icon-triangulo",
        label: "triangulo",
        icon: <Triangle size={24} />,
        name: 'triangulo',
    },
    {
        key: "icon-big-down-arrow",
        icon: <ArrowBigDown size={24} />,
        label: "big-down-arrow",
        name: 'big-down-arrow',
    },
    {
        icon: <ChevronsDown size={24} />,
        key: "icon-chevrons-down",
        label: "chevrons-down",
        name: 'chevrons-down',
    },
    {
        icon: <SquareChevronDown size={24} />,
        key: "icon-square-chevron-down",
        label: "square-chevron-down",
        name: 'square-chevron-down',
    },
    {
        icon: <Dot size={24} />,
        key: "icon-dot",
        label: "dot",
        name: 'dot',
    },
    {
        icon: <ArrowBigDownDash size={24} />,
        key: "icon-arrow-big-down-dash",
        label: "arrow-big-down-dash",
        name: 'arrow-big-down-dash',
    },
    {
        icon: <MoveDown size={24} />,
        key: "icon-move-down",
        label: "move-down",
        name: 'move-down',
    },
    {
        icon: <ArrowDown size={24} />,
        key: "icon-arrow-down",
        label: "arrow-down",
        name: 'arrow-down',
    }
];

const IconPicker = () => {
    const { changeFaqIcon } = useFAQEditor();

    const handleIconSelect = (icon: FAQIcon) => {
        changeFaqIcon({
            name: icon.name,
            key: icon.key,
            label: icon.label,
        });
    }

    return (
        <DropdownMenu>
            <DropdownMenuTrigger>
                <Button variant='navigable'>
                    Escolher Ícone
                    <ChevronRight size={16} className="text-gray-500" />
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="center" side="right" sideOffset={20} className="min-h-[112px] w-[200px]">
                <div className="flex flex-wrap gap-2">
                    {ICONS.map((item) => (
                        <button
                            key={item.key}
                            type="button"
                            title={item.label}
                            onClick={() => handleIconSelect(item)}
                            className="relative size-16 rounded-md bg-white border border-gray-200 hover:border-gray-300 transition flex items-center justify-center text-[11px] font-medium text-gray-600"
                        >
                            {item.icon}
                        </button>
                    ))}
                </div>
            </DropdownMenuContent>
        </DropdownMenu>
    )
};

export default IconPicker;